// @ts-nocheck
document.addEventListener("DOMContentLoaded", () => {
  
  /* ==========================================================================
     1. CINEMATIC VIDEO PRELOADER
     ========================================================================== */
  const preloader = document.getElementById('preloader');
  const vid = document.getElementById('intro-vid');
  
  const HOLD_TIME = 4.5; 
  const START_SPEED = 1.8;
  const END_SPEED = 1.4;

  if (vid && preloader) {
    vid.currentTime = 0;
    vid.play();

    vid.addEventListener('timeupdate', () => {
      if (vid.currentTime < HOLD_TIME) {
        let progress = vid.currentTime / HOLD_TIME;
        vid.playbackRate = START_SPEED - ((START_SPEED - END_SPEED) * progress);
      } else {
        vid.playbackRate = 1.8;
        if (vid.currentTime > 5.8 && !preloader.classList.contains('fade-away')) {
          preloader.classList.add('fade-away');
          document.body.classList.remove('loading');
          document.body.classList.add('site-loaded');
        }
      }
    });

    preloader.addEventListener('transitionend', () => preloader.remove());
  } else {
    document.body.classList.remove('loading');
    document.body.classList.add('site-loaded');
  }


  /* ==========================================================================
     2. CUSTOM LAGGING CURSOR
     ========================================================================== */
  const cursorDot = document.getElementById("cursor-dot");
  const cursorRing = document.getElementById("cursor-ring");
  
  if (window.matchMedia("(pointer: fine)").matches) {
    document.body.classList.add('custom-cursor-active'); 

    window.addEventListener("mousemove", (e) => {
      const posX = e.clientX;
      const posY = e.clientY;

      cursorDot.style.left = `${posX}px`;
      cursorDot.style.top = `${posY}px`;

      cursorRing.animate({ left: `${posX}px`, top: `${posY}px` }, { duration: 150, fill: "forwards" });
    });

    const interactiveSelectors = 'a, button, select, .product-card, .atmosphere-card, details summary';
    document.querySelectorAll(interactiveSelectors).forEach((el) => {
      el.addEventListener("mouseenter", () => {
        cursorDot.classList.add("hovered");
        cursorRing.classList.add("hovered");
      });
      el.addEventListener("mouseleave", () => {
        cursorDot.classList.remove("hovered");
        cursorRing.classList.remove("hovered");
      });
    });
  }


  /* ==========================================================================
     3. MAGNETIC BUTTON PHYSICS
     ========================================================================== */
  const magneticElements = document.querySelectorAll('.magnetic-btn, .magnetic-link');
  
  magneticElements.forEach(btn => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = `translate(${x * 0.3}px, ${y * 0.3}px)`;
    });

    btn.addEventListener('mouseleave', () => btn.style.transform = `translate(0px, 0px)`);
  });


  /* ==========================================================================
     4. 3D TILT EFFECT (Product Cards)
     ========================================================================== */
  const tiltCards = document.querySelectorAll('[data-tilt]');
  
  tiltCards.forEach(card => {
    const innerCard = card.querySelector('.card-inner');
    
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left; 
      const y = e.clientY - rect.top;  
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const maxRotate = 10; 
      const rotateX = ((y - centerY) / centerY) * -maxRotate;
      const rotateY = ((x - centerX) / centerX) * maxRotate;
      
      innerCard.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });
    
    card.addEventListener('mouseleave', () => {
      innerCard.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg)`;
    });
  });


  /* ==========================================================================
     5. DYNAMIC PARALLAX SCROLL (Supports multiple sections)
     ========================================================================== */
  const parallaxContainers = document.querySelectorAll('.parallax-container');
  
  window.addEventListener('scroll', () => {
    parallaxContainers.forEach(container => {
      const rect = container.getBoundingClientRect();
      const img = container.querySelector('.parallax-img');
      
      // Only animate if element is within the viewport
      if (img && rect.top <= window.innerHeight && rect.bottom >= 0) {
        const speed = 0.20; 
        const yOffset = rect.top * speed;
        img.style.transform = `translateY(${yOffset}px)`;
      }
    });
  });


  /* ==========================================================================
     6. SCROLL REVEALS
     ========================================================================== */
  const revealElements = document.querySelectorAll('.fade-up, .reveal-on-scroll');
  
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 0.15, rootMargin: "0px 0px -50px 0px" });

  revealElements.forEach(el => revealObserver.observe(el));


  /* ==========================================================================
     7. PRODUCT CATEGORY FILTERING & PRICE SORTING
     ========================================================================== */
  const filterBtns = document.querySelectorAll('.filter-btn');
  const sortDropdown = document.getElementById('price-sort');
  const productGrid = document.getElementById('product-grid');
  
  // Filtering
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filterValue = btn.getAttribute('data-filter');
      const productCards = document.querySelectorAll('.product-card');

      productCards.forEach(card => {
        if (filterValue === 'all' || card.getAttribute('data-category') === filterValue) {
          card.style.display = 'block';
          setTimeout(() => { card.style.opacity = '1'; }, 50);
        } else {
          card.style.opacity = '0';
          setTimeout(() => { card.style.display = 'none'; }, 300);
        }
      });
    });
  });

  // Sorting
  if (sortDropdown && productGrid) {
    sortDropdown.addEventListener('change', (e) => {
      const sortDirection = e.target.value;
      if (sortDirection === 'default') return;

      const cardsArray = Array.from(productGrid.querySelectorAll('.product-card'));
      
      cardsArray.sort((a, b) => {
        const priceA = parseInt(a.getAttribute('data-price-val'));
        const priceB = parseInt(b.getAttribute('data-price-val'));
        return sortDirection === 'low' ? priceA - priceB : priceB - priceA;
      });

      // Clear grid and append in new order
      productGrid.innerHTML = '';
      cardsArray.forEach(card => productGrid.appendChild(card));
    });
  }


  /* ==========================================================================
     8. SMART SCENT PROFILE QUIZ
     ========================================================================== */
  const quizModal = document.getElementById('quiz-modal');
  const openQuizBtn = document.getElementById('open-quiz');
  const closeQuizBtn = document.getElementById('close-quiz');
  
  const step1 = document.getElementById('quiz-step-1');
  const step2 = document.getElementById('quiz-step-2');
  const step3 = document.getElementById('quiz-step-3');
  const resultStep = document.getElementById('quiz-result');

  let userProfile = { time: '', vibe: '', intensity: '' };

  if (openQuizBtn && quizModal) {
    openQuizBtn.addEventListener('click', () => {
      document.body.classList.add('modal-open');
      quizModal.showModal();
      step1.style.display = 'block';
      step2.style.display = 'none';
      step3.style.display = 'none';
      resultStep.style.display = 'none';
    });
  }

  if (closeQuizBtn) {
    closeQuizBtn.addEventListener('click', () => {
      quizModal.close();
      document.body.classList.remove('modal-open');
    });
  }

  // Quiz Engine Data
  const recommendations = [
    { name: 'Mystic Aura', time: 'day', vibe: 'sweet', img: 'folder1/MYSTICAURA.png', price: 'Rs.3,300.00', desc: 'A vibrant, sweet, and fruity daytime signature.' },
    { name: 'Intensely', time: 'night', vibe: 'warm', img: 'folder1/INTENSELY_1000x.png', price: 'Rs.3,000.00', desc: 'Warm spices and deep vanilla for an unforgettable evening.' },
    { name: 'Megamare', time: 'day', vibe: 'fresh', img: 'folder1/MEGAMARE.png', price: 'Rs.3,500.00', desc: 'A bold, loud oceanic masterpiece.' },
    { name: 'Lui', time: 'day', vibe: 'fresh', img: 'folder1/LUI.png', price: 'Rs.4,000.00', desc: 'A crisp citrus and black tea blend for subtle elegance.' },
    { name: 'Sugar Daddy', time: 'night', vibe: 'warm', img: 'folder1/SUGARDADDY.png', price: 'Rs.3,500.00', desc: 'Deep amber spice with a magnetic, loud pull.' },
    { name: 'WHYYY!', time: 'day', vibe: 'fresh', img: 'folder1/WHYYY_1000x.png', price: 'Rs.2,600.00', desc: 'Fresh, woody, and perfect for the office.' }
  ];

  // Step 1 -> Step 2
  if (step1 && step2) {
    step1.querySelectorAll('.quiz-ans-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        userProfile.time = btn.getAttribute('data-time');
        step1.style.display = 'none';
        step2.style.display = 'block';
      });
    });
  }
  
  // Step 2 -> Step 3
  if (step2 && step3) {
    step2.querySelectorAll('.quiz-ans-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        userProfile.vibe = btn.getAttribute('data-vibe');
        step2.style.display = 'none';
        step3.style.display = 'block';
      });
    });
  }

  // Step 3 -> Calculate Result (The Scoring Algorithm)
  if (step3 && resultStep) {
    step3.querySelectorAll('.quiz-ans-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        userProfile.intensity = btn.getAttribute('data-intensity');
        
        // Give each perfume its specific tags for the algorithm to score
        const algorithmData = [
          { name: 'Mystic Aura', time: 'day', vibe: 'sweet', intensity: 'loud', img: 'folder1/MYSTICAURA.png', price: 'Rs.3,300.00', desc: 'A vibrant, sweet, and fruity daytime signature.' },
          { name: 'Intensely', time: 'night', vibe: 'warm', intensity: 'loud', img: 'folder1/INTENSELY_1000x.png', price: 'Rs.3,000.00', desc: 'Warm spices and deep vanilla for an unforgettable evening.' },
          { name: 'Megamare', time: 'day', vibe: 'fresh', intensity: 'loud', img: 'folder1/MEGAMARE.png', price: 'Rs.3,500.00', desc: 'A bold, loud oceanic masterpiece.' },
          { name: 'Lui', time: 'day', vibe: 'fresh', intensity: 'subtle', img: 'folder1/LUI.png', price: 'Rs.4,000.00', desc: 'A crisp citrus and black tea blend for subtle elegance.' },
          { name: 'Sugar Daddy', time: 'night', vibe: 'warm', intensity: 'loud', img: 'folder1/SUGARDADDY.png', price: 'Rs.3,500.00', desc: 'Deep amber spice with a magnetic, loud pull.' },
          { name: 'WHYYY!', time: 'day', vibe: 'fresh', intensity: 'subtle', img: 'folder1/WHYYY_1000x.png', price: 'Rs.2,600.00', desc: 'Fresh, woody, and perfect for the office.' },
          { name: 'Yam Pistachio', time: 'night', vibe: 'sweet', intensity: 'subtle', img: 'folder1/YAMPISTACHIO.png', price: 'Rs.3,000.00', desc: 'A subtle, sweet gourmand for intimate evenings.' }
        ];

        let bestMatch = algorithmData[0];
        let highestScore = -1;

        // Loop through and score each perfume
        algorithmData.forEach(p => {
          let score = 0;
          if (p.time === userProfile.time) score += 1;
          if (p.vibe === userProfile.vibe) score += 3; // Vibe is the most important
          if (p.intensity === userProfile.intensity) score += 1;

          if (score > highestScore) {
            highestScore = score;
            bestMatch = p;
          }
        });
        
        document.getElementById('result-name').innerText = bestMatch.name;
        document.getElementById('result-desc').innerText = bestMatch.desc;
        document.getElementById('result-img').src = bestMatch.img;

        const viewBtn = document.getElementById('result-view-btn');
        if (viewBtn) {
          viewBtn.setAttribute('data-name', bestMatch.name);
          viewBtn.setAttribute('data-price', bestMatch.price);
          viewBtn.setAttribute('data-img', bestMatch.img);
        }

        step3.style.display = 'none';
        resultStep.style.display = 'block';
      });
    });
  }

  /* ==========================================================================
     9. QUICK VIEW MODAL & CART DRAWER
     ========================================================================== */
  const qvModal = document.getElementById('quick-view-modal');
  const qvClose = document.getElementById('close-modal');
  
  // Make the entire product card open the Quick View window
  document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('click', (e) => {
      // If the user specifically clicked the Add to Cart button, don't open the modal
      if (e.target.closest('.add-cart-btn')) return;

      // Find the hidden data on the Quick View button inside this card
      const dataBtn = card.querySelector('.quick-view-btn');
      if (dataBtn && qvModal) {
        document.getElementById('qv-title').innerText = dataBtn.getAttribute('data-name');
        document.getElementById('qv-price').innerText = dataBtn.getAttribute('data-price');
        document.getElementById('qv-img').src = dataBtn.getAttribute('data-img');
        
        document.body.classList.add('modal-open');
        qvModal.showModal();
      }
    });
  });

  // Allows the Quiz result button to also open the Quick View
  const resultViewBtn = document.getElementById('result-view-btn');
  if (resultViewBtn && qvModal && quizModal) {
    resultViewBtn.addEventListener('click', () => {
      document.getElementById('qv-title').innerText = resultViewBtn.getAttribute('data-name');
      document.getElementById('qv-price').innerText = resultViewBtn.getAttribute('data-price');
      document.getElementById('qv-img').src = resultViewBtn.getAttribute('data-img');
      
      quizModal.close(); // Close quiz
      qvModal.showModal(); // Open product details
    });
  }

  if(qvClose && qvModal) {
    qvClose.addEventListener('click', () => {
      qvModal.close();
      document.body.classList.remove('modal-open');
    });
  }
  
  const cartToggle = document.getElementById('cart-toggle');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const closeCart = document.getElementById('close-cart');
  let cartCount = 0;

  function openCart() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.add('open');
      cartOverlay.classList.add('active');
    }
  }

  function closeCartDrawer() {
    if (cartDrawer && cartOverlay) {
      cartDrawer.classList.remove('open');
      cartOverlay.classList.remove('active');
    }
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (closeCart) closeCart.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // Cart Add Simulation (Main Products & Upsell)
  const addButtons = document.querySelectorAll('.add-cart-btn, .upsell-add-btn');
  addButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      cartCount++;
      const cartCountEl = document.getElementById('cart-count');
      if (cartCountEl) cartCountEl.innerText = cartCount;
      
      const originalText = btn.innerText;
      btn.innerText = "Added!";
      btn.style.backgroundColor = "var(--accent-gold)";
      btn.style.color = "#fff";
      
      setTimeout(() => {
        btn.innerText = originalText;
        btn.style.backgroundColor = "";
        btn.style.color = "";
      }, 1500);
      
      // Auto open cart if it isn't an upsell button being clicked inside the cart
      if (!btn.classList.contains('upsell-add-btn')) openCart();
    });
  });


  /* ==========================================================================
     10. THE EASTER EGG (The "Aura" Spotlight)
     ========================================================================== */
  const auraSpotlight = document.createElement('div');
  auraSpotlight.style.cssText = `
    position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
    pointer-events: none; z-index: 99990; opacity: 0;
    transition: opacity 1.5s ease;
    background: radial-gradient(circle 250px at var(--x, 50%) var(--y, 50%), transparent 0%, rgba(0,0,0,0.95) 100%);
  `;
  document.body.appendChild(auraSpotlight);

  window.addEventListener('mousemove', (e) => {
    auraSpotlight.style.setProperty('--x', e.clientX + 'px');
    auraSpotlight.style.setProperty('--y', e.clientY + 'px');
  });

  let pressedKeys = [];
  const secretCode = 'aura';

  window.addEventListener('keydown', (e) => {
    if(e.key.length !== 1) return;
    
    pressedKeys.push(e.key.toLowerCase());
    if (pressedKeys.length > secretCode.length) pressedKeys.shift();
    
    if (pressedKeys.join('') === secretCode) {
      const isActive = auraSpotlight.style.opacity === '1';
      auraSpotlight.style.opacity = isActive ? '0' : '1';
      pressedKeys = []; 
    }
  });

});